import React, { Component } from 'react';
import AppUrl from '../../restApi/AppUrl';
import IRestClient from '../../restApi/IRestClient';
import Wentwrong from '../Wentwrong/Wentwrong';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPlay, FaVideo, FaTimes, FaFilm } from 'react-icons/fa';
import ReactPaginate from 'react-paginate';

const videoCardVariants = {
  hidden: { opacity: 0, y: 32 },
  visible: i => ({
    opacity: 1, y: 0,
    transition: { duration: 0.46, delay: (i % 12) * 0.07, ease: [0.22, 1, 0.36, 1] }
  })
};

const headerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.11 } }
};

const headerItem = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] } }
};

class Allvideogallery extends Component {
  constructor() {
    super();
    this.state = {
      myData: [],
      error: false,
      loading: true,
      limit: 12,
      paginatedData: [],
      hoveredVideo: null,
      selectedVideo: null,
      isModalOpen: false
    };
  }

  componentDidMount() {
    IRestClient.GetRequest(AppUrl.allvideos).then(result => {
      if (result == null) {
        this.setState({ error: true, loading: false });
      } else {
        this.setState({
          myData: result,
          paginatedData: result.slice(0, this.state.limit),
          loading: false
        });
      }
    }).catch(() => {
      this.setState({ error: true, loading: false });
    });
  }

  componentWillUnmount() {
    document.body.style.overflow = '';
  }

  getYouTubeVideoId = (url) => {
    if (!url) return null;
    const patterns = [
      /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/,
      /youtube\.com\/v\/([^&\n?#]+)/,
      /youtube\.com\/watch\?.*v=([^&\n?#]+)/
    ];
    for (let pattern of patterns) {
      const match = url.match(pattern);
      if (match) return match[1];
    }
    return null;
  };

  getYouTubeThumbnail = (url) => {
    const videoId = this.getYouTubeVideoId(url);
    return videoId ? `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg` : null;
  };

  getFallbackThumbnail = (url) => {
    const videoId = this.getYouTubeVideoId(url);
    return videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : null;
  };

  handleHover = (index) => this.setState({ hoveredVideo: index });
  handleLeave = () => this.setState({ hoveredVideo: null });

  openVideoModal = (videoData) => {
    this.setState({ selectedVideo: videoData, isModalOpen: true });
    document.body.style.overflow = 'hidden';
  };

  closeVideoModal = () => {
    this.setState({ selectedVideo: null, isModalOpen: false });
    document.body.style.overflow = 'unset';
  };

  handlePageClick = (data) => {
    const offset = data.selected * this.state.limit;
    this.setState({ paginatedData: this.state.myData.slice(offset, offset + this.state.limit) });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  render() {
    if (this.state.loading) {
      return (
        <section className="min-h-screen bg-gray-50 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Header skeleton */}
            <div className="text-center mb-14">
              <div className="skel h-7 w-52 rounded-full mx-auto mb-5" />
              <div className="skel h-11 w-72 rounded-xl mx-auto mb-3" />
              <div className="skel h-11 w-48 rounded-xl mx-auto mb-5" />
              <div className="skel h-1 w-16 rounded-full mx-auto mb-5" />
              <div className="skel h-4 w-96 rounded mx-auto mb-2" />
              <div className="skel h-4 w-72 rounded mx-auto" />
            </div>
            {/* Video cards skeleton */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {[1, 2, 3, 4, 5, 6].map(i => (
                <div key={i} className="rounded-2xl overflow-hidden border border-gray-200" style={{ background: '#1a1a2e', boxShadow: '0 4px 24px rgba(0,0,0,0.12)' }}>
                  <div className="skel w-full" style={{ aspectRatio: '16 / 9', borderRadius: 0, opacity: 0.45 }} />
                  <div style={{ padding: '14px 16px' }}>
                    <div className="skel h-4 w-3/4 rounded mb-2" style={{ opacity: 0.35 }} />
                    <div className="skel h-3 w-1/3 rounded" style={{ opacity: 0.25 }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      );
    }
    if (this.state.error) return <Wentwrong />;

    const { paginatedData, hoveredVideo, isModalOpen, selectedVideo } = this.state;

    return (
      <>
        <section className="min-h-screen bg-gray-50 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

            {/* ── Header ── */}
            <motion.div
              className="text-center mb-14"
              variants={headerVariants}
              initial="hidden"
              animate="visible"
            >
              <motion.span
                className="inline-flex items-center gap-2 bg-green-50 border border-green-200 text-green-700 text-xs font-semibold uppercase tracking-widest px-5 py-2 rounded-full mb-5"
                variants={headerItem}
              >
                <FaFilm />
                Complete Video Collection
              </motion.span>

              <motion.h1
                className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-4 leading-tight"
                variants={headerItem}
              >
                Explore Our{' '}
                <span
                  style={{
                    background: 'linear-gradient(to right, #2E8B54, #1B2B5C)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent'
                  }}
                >
                  Video Gallery
                </span>
              </motion.h1>

              <motion.div
                className="w-16 h-1 rounded-full mx-auto mb-5"
                style={{ background: 'linear-gradient(to right, #2E8B54, #1B2B5C)', scaleX: 0 }}
                animate={{ scaleX: 1 }}
                transition={{ delay: 0.45, duration: 0.75, ease: [0.22, 1, 0.36, 1] }}
              />

              <motion.p
                className="text-gray-500 text-base sm:text-lg max-w-2xl mx-auto leading-relaxed"
                variants={headerItem}
              >
                Every video tells a story of transformation and hope. Watch how we're making a difference.
              </motion.p>
            </motion.div>

            {/* ── Grid ── */}
            {paginatedData.length === 0 ? (
              <div className="text-center py-20 text-gray-400">
                <FaVideo className="text-5xl mx-auto mb-4 opacity-30" />
                <p className="text-lg">No videos available yet.</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-14">
                {paginatedData.map((vid, index) => (
                  <motion.div
                    key={index}
                    className="group relative rounded-2xl overflow-hidden cursor-pointer bg-black border border-gray-200"
                    style={{ boxShadow: '0 4px 24px rgba(0,0,0,0.12)' }}
                    custom={index}
                    variants={videoCardVariants}
                    initial="hidden"
                    animate="visible"
                    whileHover={{ y: -5, boxShadow: '0 16px 44px rgba(0,0,0,0.24)', transition: { duration: 0.22 } }}
                    onMouseEnter={() => this.handleHover(index)}
                    onMouseLeave={this.handleLeave}
                    onClick={() => this.openVideoModal(vid)}
                  >
                    {/* 16/9 */}
                    <div className="relative w-full aspect-video">

                      <img
                        src={this.getYouTubeThumbnail(vid.video_link) || this.getFallbackThumbnail(vid.video_link)}
                        alt={vid.video_title}
                        className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          const fb = e.target.nextSibling;
                          if (fb) fb.style.display = 'flex';
                        }}
                      />

                      {/* Fallback */}
                      <div
                        className="absolute inset-0 items-center justify-center hidden"
                        style={{ background: 'linear-gradient(135deg, #2E8B54, #1B2B5C)' }}
                      >
                        <FaVideo className="text-white/30 text-5xl" />
                      </div>

                      {/* Gradient */}
                      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />

                      {/* Hover dim */}
                      <div
                        className="absolute inset-0 bg-black/20 transition-opacity duration-300"
                        style={{ opacity: hoveredVideo === index ? 1 : 0 }}
                      />

                      {/* Play */}
                      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                        <motion.div
                          className="relative flex items-center justify-center"
                          animate={{ scale: hoveredVideo === index ? 1.12 : 1 }}
                          transition={{ duration: 0.3, type: 'spring', damping: 15 }}
                        >
                          {hoveredVideo === index && (
                            <span className="absolute w-16 h-16 rounded-full border-2 border-white/40 animate-ping" />
                          )}
                          <div className="w-14 h-14 rounded-full bg-white/20 backdrop-blur-md border border-white/30 flex items-center justify-center shadow-xl transition-colors duration-300 group-hover:bg-white/35">
                            <FaPlay className="text-white text-base ml-0.5" />
                          </div>
                        </motion.div>
                      </div>

                      {/* Info */}
                      <div className="absolute bottom-0 left-0 right-0 p-4">
                        <h3 className="text-white font-semibold text-sm leading-snug line-clamp-2 mb-1.5">
                          {vid.video_title}
                        </h3>
                        <div className="flex items-center gap-1.5 text-green-400 text-xs font-semibold">
                          <FaPlay className="text-[10px]" />
                          Watch Now
                        </div>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>
            )}

            {/* ── Pagination ── */}
            {this.state.myData.length > this.state.limit && (
              <motion.div
                className="flex justify-center"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5, duration: 0.5 }}
              >
                <div className="bg-white rounded-2xl px-4 py-3 shadow-md border border-gray-100">
                  <ReactPaginate
                    breakLabel="..."
                    nextLabel="Next ›"
                    previousLabel="‹ Prev"
                    onPageChange={this.handlePageClick}
                    pageRangeDisplayed={4}
                    pageCount={Math.ceil(this.state.myData.length / this.state.limit)}
                    renderOnZeroPageCount={null}
                    containerClassName="pagination justify-content-center mb-0"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    activeClassName="active"
                  />
                </div>
              </motion.div>
            )}
          </div>
        </section>

        {/* ── Modal ── */}
        <AnimatePresence>
          {isModalOpen && selectedVideo && (
            <motion.div
              className="fixed inset-0 z-[999] flex items-center justify-center px-4"
              style={{ background: 'rgba(0,0,0,0.96)', backdropFilter: 'blur(14px)' }}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.25 }}
              onClick={this.closeVideoModal}
            >
              <motion.button
                className="absolute top-5 right-5 w-11 h-11 rounded-full bg-white/10 border border-white/20 flex items-center justify-center text-white hover:bg-white/20 transition-colors duration-200 z-10"
                onClick={e => { e.stopPropagation(); this.closeVideoModal(); }}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.15 }}
              >
                <FaTimes />
              </motion.button>

              <motion.div
                className="relative w-full max-w-5xl"
                initial={{ scale: 0.92, opacity: 0, y: 16 }}
                animate={{ scale: 1, opacity: 1, y: 0 }}
                exit={{ scale: 0.92, opacity: 0, y: 16 }}
                transition={{ duration: 0.3, type: 'spring', damping: 22 }}
                onClick={e => e.stopPropagation()}
              >
                <p className="text-white/50 text-sm text-center mb-3 px-2 line-clamp-1">
                  {selectedVideo.video_title}
                </p>
                <div className="relative w-full aspect-video rounded-2xl overflow-hidden border border-white/10 shadow-2xl">
                  <iframe
                    src={selectedVideo.video_link}
                    title={selectedVideo.video_title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                    className="w-full h-full border-0"
                  />
                </div>
                <p className="text-center mt-3 text-white/25 text-xs">Click outside to close</p>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </>
    );
  }
}

export default Allvideogallery;
